<template>
  <div>
    <header-title :Title="$route.query.FolderName"></header-title>
    <div>
      <el-card style="border-radius: 0.25rem">
        <div class="flex" style="justify-content: flex-end">
          <!-- 新建文件 -->
          <div class="flex-items">
            <div
              v-if="parentId != oldParentId"
              class="tui-addCloud"
              style="background: #fff; border: 1px solid #d9d9d9"
              @click="onClickBackFile"
            >
              <div style="color: #333">返回上一级</div>
            </div>
            <div
              class="tui-addCloud"
              @click="onClickDownAll"
              style="background: #fff; border: 1px solid #d9d9d9"
            >
              <i class="el-icon-download"></i>
              <div style="color: #333">批量下载</div>
            </div>
            <div
              v-if="$route.query.current == 0"
              class="tui-addCloud"
              style="background: #fff; border: 1px solid #d9d9d9"
              @click="onClickUpload('first')"
            >
              <img
                src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-4/20220804152117_9073.png"
                alt=""
              />
              <div style="color: #333">大文件上传</div>
            </div>
            <div
              v-if="$route.query.current == 0"
              class="tui-addCloud"
              style="background: #fff; border: 1px solid #d9d9d9"
              @click="onClickUploadAll('two')"
            >
              <img
                src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-4/20220804152117_9073.png"
                alt=""
              />
              <div style="color: #333">上传</div>
            </div>
            <div
              class="tui-addCloud"
              @click="onClickAdd"
              v-if="$route.query.current == 0"
            >
              <img
                src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-4/20220804141844_0242.png"
                alt=""
              />
              <div>新建文件夹</div>
            </div>
          </div>
        </div>
        <div v-if="CustomHX_FolderInfo.length != 0">
          <div class="tui-cloudStorage">自定义文件夹</div>
          <div class="tui-cloudList">
            <div
              class="tui-cloudListItem"
              v-for="(item, index) in CustomHX_FolderInfo"
              :key="index"
            >
              <el-dropdown
                v-if="$route.query.current == 0 || $route.query.current == 2"
                class="tui-cloudRight"
                @command="handleCommand($event, item)"
              >
                <img
                  src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-4/20220804143709_5529.png"
                  alt=""
                />
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item class="flex-items" command="refresh">
                    <i class="el-icon-edit-outline"></i>
                    <div>重命名</div>
                  </el-dropdown-item>
                  <el-dropdown-item
                    class="flex-items"
                    command="delete"
                    v-if="$route.query.current == 0"
                  >
                    <i class="el-icon-delete"></i>
                    <div>删除</div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>

              <div class="tui-cloudContent" @click="onClickDetailFile(item)">
                <img
                  src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-4/20220804143952_6872.png"
                  alt=""
                />
                <div>{{ item.FolderName }}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 文件列表 -->
        <el-table
          :data="FileInfoList"
          style="width: 100%"
          @selection-change="FileHandleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column label="文件名" align="center">
            <template slot-scope="scope">
              <div class="flex-items">
                <img :src="getImgData(scope.row.Suffix, scope.row)" alt="" />
                <div>{{ scope.row.FileName + "." + scope.row.Suffix }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="UserName" label="所属人" align="center">
          </el-table-column>
          <el-table-column prop="CreateTime" label="时间" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="onClickDownload(scope.row)"
                >下载</el-button
              >
              <el-button type="text" @click="onClickFileName(scope.row)"
                >重命名</el-button
              >
              <el-button
                type="text"
                v-if="$route.query.current != 1"
                style="color: #fe706b"
                @click="DeleteHx_Cloud_FileInfo(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <!-- <div class="tui-feishu" v-if="FileInfoList.length != 0">
          <div class="tui-cloudStorage">文档</div>
          <div class="tui-feishuItem">
            <div class="flex-items">
              <div style="width: 2.5rem; font-size: 16px">文件名</div>
            </div>
            <div class="flex-items">
              <div style="width: 2.5rem; font-size: 16px">所属人</div>
              <div style="width: 3.75rem; font-size: 16px">时间</div>
              <div style="width: 2.5rem; font-size: 16px">操作</div>
            </div>
          </div>
          <div
            class="tui-feishuItem"
            v-for="(item, index) in FileInfoList"
            :key="index"
          >
            <div class="flex-items">
              <img :src="getImgData(item.Suffix, item)" alt="" />
              <div>{{ getNameData(item) }}.{{ item.Suffix }}</div>
            </div>
            <div class="flex-items">
              <div style="width: 2.5rem">
                {{ item.UserName }}
              </div>
              <div style="width: 3.75rem">
                {{ item.CreateTime }}
              </div>
              <div style="width: 2.5rem">
                <el-button type="text" @click="onClickDownload(item)"
                  >下载</el-button
                >
                <el-button
                  type="text"
                  v-if="$route.query.current != 1"
                  style="color: #fe706b"
                  @click="DeleteHx_Cloud_FileInfo(item)"
                  >删除</el-button
                >
              </div>
            </div>
          </div>
        </div> -->
        <!-- <el-empty
          v-if="FileInfoList.length == 0 && CustomHX_FolderInfo.length == 0"
          description="暂无数据"
        ></el-empty> -->
      </el-card>
    </div>
    <!-- 上传 -->
    <el-dialog
      title="上传"
      :visible.sync="dialogVisibleImport"
      width="30%"
      center
    >
      <div class="flex-center">
        <el-upload
          :file-list="fileListArr"
          class="image-uploader"
          :auto-upload="true"
          ref="upload"
          :show-file-list="true"
          :drag="true"
          action
          :limit="1"
          :on-exceed="handleExceed"
          :before-upload="beforeUpload"
          :http-request="afterRead"
          :on-remove="handleRemoveFj"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            一次只能上传一个文件，单文件不超过1G
          </div>
        </el-upload>
      </div>

      <div
        class="loadingModal"
        :style="{ height: '100%' }"
        v-if="progressLoading"
      >
        <el-progress
          :stroke-width="20"
          :text-inside="true"
          :percentage="progress"
          :color="colors"
        ></el-progress>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleImport = false">取消</el-button>
        <el-button type="primary" @click="ImportStudent">提交</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="上传"
      :visible.sync="dialogVisibleImportAll"
      width="30%"
      center
    >
      <div class="flex-center">
        <el-upload
          :http-request="afterReadBatch"
          :file-list="fileList"
          class="image-uploader"
          multiple
          :auto-upload="true"
          ref="upload"
          :show-file-list="true"
          :drag="true"
          action
          :limit="10"
          :before-upload="TwoBeforeUpload"
          :on-remove="TwoHandleRemoveFj"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            上传多个文件，单文件不超过50M
          </div>
        </el-upload>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleImportAll = false">取消</el-button>
        <el-button type="primary" @click="ImportStudent">提交</el-button>
      </div>
    </el-dialog>
    <!-- 创建文件夹 -->
    <el-dialog :title="cloudTitle" :visible.sync="dialogVisible" width="30%">
      <div>
        <el-form ref="form" :model="form" label-position="top">
          <el-form-item label="文件夹名称:">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" round>取 消</el-button>
        <el-button
          round
          type="primary"
          style="background: #27abf7"
          @click="onClickAddCloud"
          >创 建</el-button
        >
      </span>
    </el-dialog>
    <!-- 删除文件夹 -->
    <el-dialog title="" :visible.sync="dialogVisibleDelete" width="20%" center>
      <div class="tui-deleteCloud">
        <img
          src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-4/20220804150425_1439.png"
          alt=""
        />
        <div>您确定要删除文件夹{{ form.name }}吗？删除后文件夹后不可恢复。</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleDelete = false" round>取 消</el-button>
        <el-button
          round
          type="primary"
          style="background: #27abf7"
          @click="onClickDeleteCloud"
          >删 除</el-button
        >
      </span>
    </el-dialog>
    <!-- 重命名文件 -->
    <el-dialog title="重命名文件" :visible.sync="dialogVisibleFile" width="30%">
      <div>
        <el-form ref="form" :model="form" label-position="top">
          <el-form-item label="文件名称:">
            <el-input v-model="fileInfo.name"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleFile = false" round>取 消</el-button>
        <el-button
          round
          type="primary"
          style="background: #27abf7"
          @click="UpdateHx_Cloud_FileInfo"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import headerTitle from "@/components/headerTitle/headerTitle.vue";
import {
  GetHx_CloudInfo,
  CreateHx_Cloud_FolderInfo,
  UpdateHx_Cloud_FolderInfo,
  DeleteHx_Cloud_FolderInfo,
  GetHx_CloudFileInfo,
  UploadFileNewCloud,
  AddHx_Cloud_FileInfo,
  UpdateHx_Cloud_FileInfo,
  DeleteHx_Cloud_FileInfo,
  AddShareInfo,
  BatchAddHx_Cloud_FileInfo,
  UploadFilesPag,
} from "../../api/api";
import JSZip from "jszip";
import FileSaver from "file-saver";
import OSS from "ali-oss";

export default {
  components: {
    headerTitle,
  },
  data() {
    return {
      shop_name: "",
      tempUrl: "", //存上传后的图片url
      dataObj: {
        region: "oss-cn-shanghai", //我的存储是北京，可根据具体配置自行修改
        accessKeyId: "LTAI5tFV2gKH9MHbHip3UUFV",
        accessKeySecret: "bew7cr5TthXrrkQkHauZG10xuqKW8z",
        bucket: "mushroomisand",
      }, //存签名信息
      baseAli: "http://mushroomisand.oss-cn-shanghai.aliyuncs.com", //我的存储是北京，可根据具体配置自行修改
      progress: 0, //进度条

      dialogVisibleImport: false,
      dialogVisible: false,
      dialogVisibleDelete: false,
      CustomHX_FolderInfo: [],
      HX_FolderInfo: [], //默认文件夹
      FileInfoList: [],
      excelurl: "",
      size: 0,
      excelName: "",
      cloudTitle: "",
      form: {
        name: "",
        FolderId: 0,
      },
      parentId: 0,
      oldParentId: 0,
      oldParentList: [],
      Arr: [],
      FolderName: "",
      dialogVisibleDown: false,
      fileUrl: "",
      loading: false,
      allDownList: [],
      progressLoading: false,
      percentage: 0,
      colors: "#32C5FF", //颜色自己规定
      numUpload: 1,
      fileListArr: [],
      firstPlayFlag: true, // 第一次播放标记
      blockNum: 0,

      activeName: "first",
      fileList: [],
      dialogVisibleImportAll: false,
      dialogVisibleFile: false,
      fileInfo: {
        name: "",
        Id: 0,
      },
    };
  },
  created() {
    this.userInfo = JSON.parse(window.localStorage.getItem("user"));
    this.parentId = this.$route.query.FolderId;
    this.FolderName = this.$route.query.FolderName;
    this.oldParentId = this.$route.query.oldFolderId;
    this.oldParentList.push(Number(this.$route.query.FolderId));

    //console.log(this.parentId, this.oldParentList);

    this.GetHx_CloudInfo();
    this.GetHx_CloudFileInfo();
  },
  methods: {
    formatDate() {
      var value = new Date();
      var year = value.getFullYear();
      var month = formatNum(value.getMonth() + 1);
      var day = formatNum(value.getDate());
      return year + "/" + month + "/" + day;
    },
    formatNum(num) {
      return num < 10 ? "0" + num : num;
    },
    //分片上传
    afterRead(file) {
      this.progress = 0;
      var that = this;
      this.progressLoading = true;
      // 此时可以自行将文件上传至服务器
      console.log(file);
      //判断扩展名

      const tmpcnt = file.file.name.lastIndexOf(".");
      const exname = file.file.name.substring(tmpcnt + 1);
      const filename = file.file.name.substring(0, tmpcnt);
      var value = new Date();
      var year = value.getFullYear();
      var month = this.formatNum(value.getMonth() + 1);
      var day = this.formatNum(value.getDate());
      var hour = this.formatNum(value.getHours());
      var min = this.formatNum(value.getMinutes());
      var sec = this.formatNum(value.getSeconds());
      var mill = this.formatNum(value.getMilliseconds());

      var time = year + "/" + month + "/" + day + "/";
      var name = year + month + day + hour + min + sec + mill;
      let client = new OSS(this.dataObj);

      const progress = (p, _checkpoint) => {
        // Object的上传进度。
        //console.log(p, "p");
        this.progress = Math.round(p * 100, 3);
        // 分片上传的断点信息。
        //console.log(_checkpoint, "_checkpoint");
      };
      // 开始分片上传。
      async function multipartUpload() {
        try {
          console.log(file.file, "file.file");
          const fileName =
            "/NewCloud/resource/" +
            that.userInfo.uID +
            "/" +
            time +
            file.file.name;

          console.log(fileName, "fileName");
          // 依次填写Object完整路径（例如exampledir/exampleobject.txt）和本地文件的完整路径（例如D:\\localpath\\examplefile.txt）。Object完整路径中不能包含Bucket名称。
          // 如果本地文件的完整路径中未指定本地路径（例如examplefile.txt），则默认从示例程序所属项目对应本地路径中上传文件。

          const result = await client.multipartUpload(fileName, file.file, {
            progress,
            // 指定meta参数，自定义Object的元信息。通过head接口可以获取到Object的meta数据。
            meta: {
              year: year,
              people: "people",
            },
          });
          console.log(result, "result");
          if (result.res.statusCode == "200") {
            that.loading = false;
            that.fileListArr.push({
              name: filename,
              url: that.baseAli + result.name,
              size: file.file.size,
            });
            that.progressLoading = false;
            console.log(that.fileListArr, "  this.fileListArr");
          }
          // // 填写Object完整路径，例如exampledir/exampleobject.txt。Object完整路径中不能包含Bucket名称。
          // const head = await client.head(fileName);
          // console.log(head);
        } catch (e) {
          // 捕获超时异常。
          if (e.code === "ConnectionTimeoutError") {
            console.log("TimeoutError");
            // do ConnectionTimeoutError operation
          }
          console.log(e, "ccc");
        }
      }
      multipartUpload();
    },
    //批量上传
    afterReadBatch(file) {
      var that = this;
      //判断扩展名
      const tmpcnt = file.file.name.lastIndexOf(".");
      const filename = file.file.name.substring(0, tmpcnt);
      var value = new Date();
      var year = value.getFullYear();
      var month = this.formatNum(value.getMonth() + 1);
      var day = this.formatNum(value.getDate());
      var hour = this.formatNum(value.getHours());
      var min = this.formatNum(value.getMinutes());
      var sec = this.formatNum(value.getSeconds());
      var mill = this.formatNum(value.getMilliseconds());
      var time = year + "/" + month + "/" + day + "/";
      var name = year + month + day + hour + min + sec + mill;
      let client = new OSS(this.dataObj);
      async function put() {
        try {
          const fileName =
            "/NewCloud/resource/" +
            that.userInfo.uID +
            "/" +
            time +
            file.file.name;

          // 填写OSS文件完整路径和本地文件的完整路径。OSS文件完整路径中不能包含Bucket名称。
          // 如果本地文件的完整路径中未指定本地路径，则默认从示例程序所属项目对应本地路径中上传文件。

          const result = await client.put(fileName, file.file);
          console.log(result, "result  ");
          if (result.res.statusCode == "200") {
            that.loading = false;
            that.fileList.push({
              name: filename,
              url: result.url,
              size: file.file.size,
            });
            that.progressLoading = false;
            console.log(that.fileList, "  this.fileList");
          }
        } catch (e) {
          console.log(e);
        }
      }

      put();
    },
    onClickUploadAll(type) {
      this.activeName = type;
      this.fileListArr = [];
      this.fileList = [];
      this.excelurl = "";
      this.excelName = "";
      // this.$refs.upload.clearFiles();
      //console.log(this.$refs.upload, "hgfhfhgf");
      this.dialogVisibleImportAll = true;
    },
    TwoUploadFile(item) {
      //    //console.log(this.comId);
      const fileObj = item.file;
      // FormData 对象
      const form = new FormData();
      // 文件对象
      form.append("file", fileObj);
      //    form.append("comId", this.comId);
      form.append("filetype", "excel");
      // //console.log(form);
      //debugger;
      UploadFileNewCloud(form).then((res) => {
        //console.log(res, fileObj);
        this.loading = false;
        this.fileList.push({
          name: fileObj.name,
          url: res.data.response,
          size: fileObj.size,
        });

        // //console.log(response);
        // //console.log(this.excelurl);
        this.$message.info("文件：" + fileObj.name + "上传成功");
      });
    },
    TwoHandleRemoveFj(file, fileList) {
      this.fileList = fileList;
    },
    handleClick(tab, e) {
      console.log(tab, e);
      this.activeName = tab.name;
    },
    getNum(val) {
      console.log((val / this.blockNum) * 100);
      return Number(((val / this.blockNum) * 100).toFixed());
    },
    handleRemoveFj(file, fileList) {
      console.log(file, fileList);
      let index = this.fileListArr.findIndex((item) => item.name == file.name);
      console.log(index, "aaaaaaaaa");
      this.fileListArr.splice(index, 1);
    },
    // 选择的批量下载的数据
    FileHandleSelectionChange(e) {
      this.allDownList = e;
      console.log(e);
    },
    onClickDownAll() {
      if (this.allDownList.length != 0) {
        var blogTitle = `批量下载文件集合`; // 下载后压缩包的命名
        var zip = new JSZip();
        var promises = [];
        let cache = {};
        let arrImg = [];
        for (let i = 0; i < this.allDownList.length; i++) {
          arrImg.push({
            path: this.allDownList[i].FileUrl, // 文件链接
            name: this.allDownList[i].FileName, // 文件名称
          });
        }
        for (let item of arrImg) {
          // item.path为文件链接地址
          const promise = this.getImgArrayBuffer(item.path).then((data) => {
            // 下载文件, 并存成ArrayBuffer对象(blob)
            zip.file(item.name, data, { binary: true }); // 逐个添加文件
            cache[item.name] = data;
          });
          promises.push(promise);
        }
        Promise.all(promises)
          .then(() => {
            zip.generateAsync({ type: "blob" }).then((content) => {
              // 生成二进制流
              FileSaver.saveAs(content, blogTitle); // 利用file-saver保存文件  自定义文件名
            });
          })
          .catch((res) => {
            alert("文件压缩失败");
          });
      } else {
        this.$message({
          type: "error",
          message: "请选择批量下载的文件",
        });
      }
    },
    //文件以流的形式获取（参数url为文件链接地址）
    getImgArrayBuffer(url) {
      return new Promise((resolve, reject) => {
        //通过请求获取文件blob格式
        let xmlhttp = new XMLHttpRequest();
        xmlhttp.open("GET", url, true);
        xmlhttp.responseType = "blob";
        xmlhttp.onload = function () {
          if (this.status == 200) {
            resolve(this.response);
          } else {
            reject(this.status);
          }
        };
        xmlhttp.send();
      });
    },
    //下载文件 　　js模拟点击a标签进行下载
    saveAs(blob, filename) {
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      link.click();
    },
    //通过文件下载url拿到对应的blob对象
    getBlob(url) {
      return new Promise((resolve) => {
        const xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.responseType = "blob";
        xhr.onload = () => {
          if (xhr.status === 200) {
            resolve(xhr.response);
          }
        };
        xhr.send();
      });
    },
    // 处理文件名称
    getNameData(item) {
      console.log(item.FileName, "item.FileName");
      // //let path2 = item.FileName.replace("." + item.Suffix, ""); //文件名称去掉路径和后缀名
      // //console.log(path2, "aaaa");
      // const tmpcnt = item.FileName.lastIndexOf(".");

      // //const exname = item.FileName.substring(tmpcnt + 1);
      // const filename = item.FileName.substring(0, tmpcnt);

      // console.log(tmpcnt, "tmpcnt");
      // //console.log(exname, "exname");
      // console.log(filename, "filename");
      return item.FileName;
    },
    // 进入下级文件夹
    onClickDetailFile(item) {
      this.parentId = item.FolderId;
      this.oldParentList.push(item.FolderId);

      this.GetHx_CloudInfo();
      this.GetHx_CloudFileInfo();
    },
    // 返回上级文件夹
    onClickBackFile() {
      if (
        this.oldParentList.length == 1 &&
        this.oldParentList[0] == this.$route.query.FolderId
      ) {
        this.$router.go(-1);
      } else {
        let Index = this.oldParentList.findIndex(
          (item) => item == this.parentId
        );
        this.oldParentList.splice(Index, 1);
        this.parentId = this.oldParentList[this.oldParentList.length - 1];
        //   let newArr = this.oldParentList.slice(0, -1);
        //console.log(this.oldParentList, this.parentId, Index);
        this.GetHx_CloudInfo();
        this.GetHx_CloudFileInfo();
      }
    },
    // 删除文件夹
    async onClickDeleteCloud() {
      let res = await DeleteHx_Cloud_FolderInfo({
        Id: this.form.FolderId,
      });
      if (res.data.success) {
        this.$message({
          type: "success",
          message: "删除文件夹成功",
        });
        this.dialogVisibleDelete = false;
        this.form.name = "";
        this.form.FolderId = 0;
        this.GetHx_CloudInfo();
        this.GetHx_CloudFileInfo();
      } else {
        this.$message({
          type: "error",
          message: res.data.msg,
        });
      }
    },
    // 删除文件夹
    handleCommand(e, item) {
      if (e == "delete") {
        this.dialogVisibleDelete = true;
        this.form.FolderId = item.FolderId;
        this.form.name = item.FolderName;
      } else {
        this.cloudTitle = "重命名文件夹";
        this.form.FolderId = item.FolderId;
        this.form.name = item.FolderName;

        this.dialogVisible = true;
      }
    },
    onClickFileName(item) {
      this.fileInfo = {
        name: item.FileName,
        Id: item.FileId,
      };
      this.dialogVisibleFile = true;
    },
    // 重命名文件
    async UpdateHx_Cloud_FileInfo() {
      let res = await UpdateHx_Cloud_FileInfo(this.fileInfo);
      if (res.data.success) {
        this.$message({
          type: "success",
          message: "重命名文件成功",
        });
        this.dialogVisibleFile = false;
        this.GetHx_CloudInfo();
        this.GetHx_CloudFileInfo();
      } else {
        this.$message({
          type: "error",
          message: res.data.msg,
        });
      }
    },
    onClickDownload(item) {
      this.fileUrl = item.FileUrl;
      var fileName = item.FileName.replace("." + item.Suffix, " "); //文件名称去掉路径和后缀名
      if (fileName != "") {
        this.getBlob(this.fileUrl).then((blob) => {
          this.saveAs(blob, fileName);
          this.dialogVisibleDown = false;
        });
      } else {
        this.$message({
          type: "warning",
          message: "请填写名称内容",
        });
      }
    },
    async DeleteHx_Cloud_FileInfo(item) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let res = await DeleteHx_Cloud_FileInfo({
          Id: item.FileId,
        });
        if (res.data.success) {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.GetHx_CloudInfo();
          this.GetHx_CloudFileInfo();
        } else {
          this.$message({
            type: "error",
            message: "删除失败!",
          });
        }
      });
    },
    // 创建文件夹
    async onClickAddCloud() {
      if (this.form.name != "") {
        if (this.cloudTitle == "创建文件夹") {
          let res = await CreateHx_Cloud_FolderInfo({
            name: this.form.name,
            parentId: this.parentId,
            UserId: this.userInfo.uID,
            isShare: 0,
            StudentId: 0,
          });
          if (res.data.success) {
            this.$message({
              type: "success",
              message: "新增文件夹成功",
            });
            this.dialogVisible = false;
            this.form.name = "";
            this.GetHx_CloudInfo();
            this.GetHx_CloudFileInfo();
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        } else {
          let res = await UpdateHx_Cloud_FolderInfo({
            name: this.form.name,
            id: this.form.FolderId,
          });
          if (res.data.success) {
            this.$message({
              type: "success",
              message: "重命名成功",
            });
            this.form.name = "";
            this.form.FolderId = 0;
            this.dialogVisible = false;
            this.GetHx_CloudInfo();
            this.GetHx_CloudFileInfo();
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        }
      } else {
        this.$message({
          type: "error",
          message: "文件夹名称不能为空",
        });
      }
    },
    onClickAdd() {
      this.cloudTitle = "创建文件夹";
      this.dialogVisible = true;
    },
    // 获取我的文件夹
    async GetHx_CloudInfo() {
      let res = await GetHx_CloudInfo({
        Type: this.$route.query.current + 1,
        UserId: this.userInfo.uID,
        StudentId: 0,
        ParentId: this.parentId,
        Name: "",
      });
      if (res.data.success) {
        this.CustomHX_FolderInfo = res.data.response.CustomHX_FolderInfo;
        this.HX_FolderInfo = res.data.response.HX_FolderInfo;
      } else {
        this.CustomHX_FolderInfo = [];
        this.HX_FolderInfo = [];
      }
    },
    async GetHx_CloudFileInfo() {
      let res = await GetHx_CloudFileInfo({
        Type: this.$route.query.current + 1,
        UserId: this.userInfo.uID,
        StudentId: 0,
        ParentId: this.parentId,
        Name: "",
      });
      if (res.data.success) {
        this.FileInfoList = res.data.response.data.map((cc) => {
          return {
            CreateTime: cc.CreateTime,
            FileId: cc.FileId,
            FileName: cc.FileName,
            FileType: cc.Suffix,
            FileUrl: cc.FileUrl,
            UpdateTime: cc.UpdateTime,
            UserName: cc.UserName,
            Suffix: cc.Suffix,
            Sort: cc.Sort,
          };
        });
      } else {
        this.FileInfoList = [];
      }
    },
    // 图片处理
    getImgData(e) {
      var ImgData = "";
      switch (e) {
        case "png":
        case "jpg":
        case "jpeg":
        case "gif":
          ImgData =
            "http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-15/20220815180305_5336.png"; //图片
          break;
        case "word":
          ImgData =
            "http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-15/20220815180448_8795.png";
          break;
        case "excel":
        case "xls":
          ImgData =
            "http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-15/20220815180531_3975.png";
          break;
        case "ppt":
          ImgData =
            "http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-15/20220815180549_5391.png";
          break;
        case "txt":
          ImgData =
            "http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-15/20220815180604_9937.png";
          break;
        default:
          ImgData =
            "http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-15/20220815180810_4622.png";
          break;
      }
      //console.log(ImgData);
      return ImgData;
    },
    onClickUpload(type) {
      this.activeName = type;
      this.excelurl = "";
      this.excelName = "";
      this.fileListArr = [];
      this.fileList = [];
      //   this.$refs.upload.clearFiles();
      //console.log(this.$refs.upload, "hgfhfhgf");
      this.dialogVisibleImport = true;
    },
    TwoBeforeUpload(file) {
      //console.log("beforeUpload");
      // //console.log(file.type);
      const isText = file.type === "application/vnd.ms-excel";
      const isTextComputer =
        file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      //1MB=1024*1024(1MB=1024KB 1KB=1024MB)
      const is10M = file.size / 1024 / 1024 < 50;

      //限制文件上传大小
      if (!is10M) {
        this.$message.error("上传图片大小不能超过 50M!");
        return false;
      }

      return true;
      // return isText | isTextComputer;
    },
    //上传文件
    async ImportStudent() {
      console.log(this.fileListArr, "fileListArr");

      if (this.activeName == "first") {
        if (this.fileListArr.length == 0) {
          this.$message({
            message: "请选择文件",
            type: "error",
          });
        } else {
          let list = this.fileListArr.map((cc) => {
            return {
              hx_Cloud_FileName: cc.name,
              hx_Cloud_FileUrl: cc.url,
              storage: cc.size,
            };
          });
          let res = await BatchAddHx_Cloud_FileInfo({
            hx_FolderId: this.parentId,
            UserId: this.userInfo.uID,
            isShare: this.currentIndex == 0 ? 0 : 1,
            StudentId: 0,
            list: this.activeName == "first" ? list : this.fileList,
          });
          if (res.data.success) {
            this.$message({
              message: "成功",
              type: "success",
            });
            this.$refs.upload.clearFiles();
            //初始化数据
            this.dialogVisibleImport = false;
            this.dialogVisibleImportAll = false;
            this.GetHx_CloudInfo();
            this.GetHx_CloudFileInfo();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        }
      } else {
        if (this.fileList.length == 0) {
          this.$message({
            message: "请选择文件",
            type: "error",
          });
        } else {
          let list = this.fileList.map((cc) => {
            return {
              hx_Cloud_FileName: cc.name,
              hx_Cloud_FileUrl: cc.url,
              storage: cc.size,
            };
          });
          let res = await BatchAddHx_Cloud_FileInfo({
            hx_FolderId: this.parentId,
            UserId: this.userInfo.uID,
            isShare: this.currentIndex == 0 ? 0 : 1,
            StudentId: 0,
            list: list,
          });
          if (res.data.success) {
            this.$message({
              message: "成功",
              type: "success",
            });
            this.$refs.upload.clearFiles();
            //初始化数据
            this.dialogVisibleImport = false;
            this.dialogVisibleImportAll = false;

            this.GetHx_CloudInfo();
            this.GetHx_CloudFileInfo();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        }
      }
    },
    //导入
    uploadFile(item) {
      // this.loading = true;
      if (this.firstPlayFlag) {
        this.progressLoading = true;
        this.firstPlayFlag = false;
      } else {
      }

      let that = this;
      console.log(this.numUpload, "uploadFile");
      var num = this.numUpload;
      this.progressPercent = num;

      const fileObj = item;
      // FormData 对象
      var file = item.file;
      const formData = new FormData();
      var time = new Date().getTime();
      //没文件为5m
      // 每片文件大小为5M
      var blockSize = 10 * 1024 * 1024;
      var blockNum = Math.ceil(file.size / blockSize);
      this.blockNum = blockNum;
      var nextSize = Math.min(num * blockSize, file.size);
      var fileData = file.slice((num - 1) * blockSize, nextSize);
      console.log(item, "fileData");
      formData.append("file", fileData);
      // 文件名
      formData.append("name", file.name);
      // 总片数
      formData.append("chunks", blockNum);
      formData.append("chunk", num);
      formData.append("md5", time);
      formData.append("uid", "13570");
      console.log(num, blockNum, "blockNum****************");
      UploadFilesPag(formData).then((response) => {
        console.log(response.data, "response.data.success");
        if (response.data.response) {
          this.numUpload = 1;
          console.log(fileObj, "fileObj");
          console.log(this, that, "this,that,uploadFile");
          this.excelurl = response.data.response;
          this.fileListArr.push({
            name: fileObj.file.name,
            url: response.data.response,
            size: fileObj.file.size,
          });
          this.excelName = fileObj.file.name;
          this.size = fileObj.file.size;
          // this.end();
          this.progressLoading = false;

          // console.log("filename", this.addForm.ContentUrl);
          this.$message.info("文件：" + item.file.name + "上传成功");

          // this.end();
        } else {
          console.log("递归");
          this.numUpload++;
          this.uploadFile(fileObj);
        }
      });
    },
    // 上传文件个数超过定义的数量
    handleExceed() {
      this.$message.warning(`当前限制选择 1 个文件，请删除后继续上传`);
    },
    beforeUpload(file) {
      //console.log("beforeUpload");
      // //console.log(file.type);
      const isText = file.type === "application/vnd.ms-excel";
      const isTextComputer =
        file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      //1MB=1024*1024(1MB=1024KB 1KB=1024MB)
      const is10M = file.size / 1024 / 1024 < 1024;

      //限制文件上传大小
      if (!is10M) {
        this.$message.error("上传图片大小不能超过 1G!");
        return false;
      }

      return true;
      // return isText | isTextComputer;
    },
  },
};
</script>
<style lang="less">
.tui-tableImg {
  img {
    width: 40px;
    height: 40px;
  }
}
.el-dialog__header {
  background: url("http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-8/20220808145755_3530.png")
    no-repeat;
  padding: 30px 20px 30px;
  background-size: 100% 100%;
}
.tui-dialog {
  border-radius: 0.25rem;
  overflow: hidden;
}
.tui-feishu {
  display: flex;
  flex-direction: column;
  .tui-feishuItem {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.2rem 0;
    box-sizing: border-box;
    border-top: 1px solid #eee;
    cursor: pointer;
    img {
      width: 0.5rem;
      height: 0.5rem;
    }
    div {
      font-size: 0.25rem;
      padding-left: 0.25rem;
    }
  }
}
.tui-deleteCloud {
  display: flex;
  align-items: center;
  flex-direction: column;
  img {
    width: 0.5rem;
    height: 0.5rem;
  }
  div {
    width: 3.625rem;
    font-size: 0.225rem;
    color: #333;
    padding-top: 0.375rem;
    line-height: 0.25rem;
  }
}
.tui-cloudStorage {
  font-size: 0.25rem;
  color: #333;
  font-weight: 600;
  padding: 0.375rem 0 0.25rem 0;
}
.tui-cloudList {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-start;
  .tui-cloudListItem:nth-of-type(5n) {
    margin-right: 0;
  }
  .tui-cloudListItem:hover {
    border: 1px solid #32c5ff;
  }
  .tui-cloudListItem {
    width: 3.55rem;
    height: 1.25rem;
    border-radius: 0.25rem;
    border: 1px solid #e9e9e9;
    position: relative;
    margin-right: 0.25rem;
    margin-bottom: 0.25rem;
    cursor: pointer;
    .tui-cloudRight {
      position: absolute;
      right: 0.15rem;
      top: 0.15rem;
      width: 0.2875rem;
      height: 0.2875rem;
      cursor: pointer;
    }
    .tui-cloudContent {
      padding: 0.3125rem 0 0 0.35rem;
      display: flex;
      align-items: center;
      img {
        width: 0.625rem;
        height: 0.625rem;
      }
      div {
        width: 1.875rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        font-size: 0.225rem;
        color: #333;
        padding-left: 0.1625rem;
      }
    }
  }
}
.tui-addCloud {
  width: 1.75rem;
  height: 0.5rem;
  background: #27abf7;
  border-radius: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 0.25rem;
  cursor: pointer;
  img {
    width: 0.2rem;
    height: 0.2rem;
  }
  div {
    color: #fff;
    font-size: 0.2rem;
    padding-left: 0.0625rem;
  }
}
.tui-tabs {
  // width: 3.2625rem;
  height: 0.5rem;
  background: #f6f6f6;
  border-radius: 0.25rem;
  color: #333;
  font-size: 0.2rem;
  display: flex;
  align-items: center;

  .tui-tabsItem {
    width: 1.7125rem;
    height: 0.5rem;
    border-radius: 0.25rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.2rem;
  }
  .tui-active {
    background: #27abf7 !important;
    color: #fff !important;
  }
}
</style>